/*
  Created by Alex
*/

import update from '../update';

import { DCM_TAG_RENDERED }from './constants';

let initialState = {renderedPreviewDcmTags: []};

/*
  Only adds all campaigns or deletes one campaign from the list
*/
const dcmReducer = (state=initialState, action) => {
  switch (action.type) {
    case DCM_TAG_RENDERED:
      return {...state, renderedPreviewDcmTags: update(state.renderedPreviewDcmTags, {$push: [action.payload]})};
    default:
      return state;
  }
}

export default dcmReducer;



// WEBPACK FOOTER //
// ./src/redux/dcm/reducer.js